import { transformLayerField, MAX_LAYER_DISPLAY_LENGTH } from '../../../utils';
export default {
    name: 'LayerRender',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
            default: null,
        },
    },
    computed: {
        formattedValue() {
            const items = transformLayerField(this.value, this.field.field_layer_value);
            if (items.length > MAX_LAYER_DISPLAY_LENGTH) {
                return {
                    items: items.slice(0, MAX_LAYER_DISPLAY_LENGTH),
                    more: items.length - MAX_LAYER_DISPLAY_LENGTH,
                };
            }
            return {
                items,
                more: 0,
            };
        },
    },
};
